import type { BlockNode } from "./BlocksRenderer";

export function findHighestBlockChange(
  oldData: BlockNode[],
  newData: BlockNode[],
): BlockNode | null {
  let highestBlock: BlockNode | null = null;

  const traverseAndCompare = (
    oldNode: BlockNode,
    newNode: BlockNode,
  ): boolean => {
    // Check if the nodes are different
    if (JSON.stringify(oldNode) !== JSON.stringify(newNode)) {
      if (newNode.blockType) {
        highestBlock = newNode;
      }
      return true;
    }

    // Recursively check children
    if (newNode.children && oldNode.children) {
      const maxLength = Math.max(
        newNode.children.length,
        oldNode.children.length,
      );
      for (let i = 0; i < maxLength; i++) {
        const oldChild = oldNode.children[i];
        const newChild = newNode.children[i];
        if (traverseAndCompare(oldChild, newChild)) {
          return true;
        }
      }
    }

    return false;
  };

  // Compare top-level content blocks
  const maxLength = Math.max(oldData.length, newData.length);
  for (let i = 0; i < maxLength; i++) {
    const oldBlock = oldData[i];
    const newBlock = newData[i];
    if (traverseAndCompare(oldBlock, newBlock)) {
      break;
    }
  }

  return highestBlock;
}
